var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import SupplierService from '../../../api/SupplierService';
import CommonService from '../../../api/CommonService';
import GLOBAL_VUE from '../../../globalVue';
var CategoryDialog = (function (_super) {
    __extends(CategoryDialog, _super);
    function CategoryDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 0;
        _this.pager = {
            limit: 10,
            start: 0,
            page: 1,
        };
        return _this;
    }
    CategoryDialog.prototype.created = function () {
        this.service = SupplierService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    CategoryDialog.prototype.mounted = function () {
        this.getCategory();
    };
    CategoryDialog.prototype.pageChange = function (pager) {
        console.log(222, this.$refs.pagination.getPage(), pager);
        this.getCategory(pager);
    };
    CategoryDialog.prototype.add = function () {
        this.listData.push({
            category_name: '',
            category_code: '',
            sort: '',
            isEdit: true
        });
    };
    CategoryDialog.prototype.saveCategory = function (row, index) {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (_this.errors.has('row_category_code' + index)) {
                _this.$message.error("类别编码只能包含字母和数字");
                return;
            }
            if (_this.errors.has('row_sort' + index) || _this.errors.has('row_category_name' + index)) {
                _this.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                return;
            }
            _this.service.saveCategory(row).then(function (res) {
                if (res.data.success) {
                    _this.$message.success('保存成功！');
                    var CALL_BACK = function (data) {
                        _this.$emit('fresh-tree');
                    };
                    _this.getCategory(_this.pager, CALL_BACK);
                    _this.$refs.pagination.clear();
                }
                else {
                    _this.$message.error(res.data.msg);
                }
                ;
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        });
    };
    CategoryDialog.prototype.editCategory = function (index) {
        GLOBAL_VUE.$set(this.listData[index], 'isEdit', true);
    };
    CategoryDialog.prototype.deleteCategory = function (category_id, index) {
        var _this = this;
        if (!category_id) {
            this.listData.splice(index, 1);
            return;
        }
        this.$confirm('请确认是否删除该类别', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.delCategory({ category_id: category_id }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success('删除成功！');
                        var CALL_BACK = function (data) {
                            _this.$emit('fresh-tree');
                        };
                        _this.getCategory(_this.pager, CALL_BACK);
                        _this.$refs.pagination.clear();
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    ;
                }).catch(function (err) {
                    _this.$message.error(err.message);
                });
            }
        }).catch(function () {
        });
    };
    CategoryDialog.prototype.getCategory = function (pager, CALL_BACK) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 10 }; }
        this.service.getCategory(Object.assign({}, pager)).then(function (res) {
            _this.listData = res.data.data || [];
            _this.total = res.data.total;
            _this.$forceUpdate();
            CALL_BACK && CALL_BACK(_this.listData);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    CategoryDialog.prototype.close = function () {
        this.$closeDialog();
    };
    CategoryDialog = __decorate([
        Component
    ], CategoryDialog);
    return CategoryDialog;
}(VueDialog));
export default CategoryDialog;
